export default class MentionableUser {
  constructor ({ id, name, surname }) {
    this.id = id
    this.name = name || ''
    this.surname = surname || ''
  }

  get fullName () {
    return [this.name, this.surname].filter(Boolean).join(' ')
  }

  get initials () {
    return this.fullName
      .split(' ')
      .map(n => n[0])
      .join('')
      .substring(0, 2)
      .toUpperCase()
  }
}



// WEBPACK FOOTER //
// ./src/app/news_feed/models/MentionableUser.js